import React from 'react';
import Icon from './Icon';

export const Warning = ({ ...props }) => (
  <Icon viewBox="0 0 14 12" {...props}>
    <svg viewBox="0 0 14 12">
      <path d="M13.517 10.185c.427.741-.11 1.667-.963 1.667H1.446a1.112 1.112 0 0 1-.963-1.667L6.038.555a1.112 1.112 0 0 1 1.925 0l5.554 9.63zM7 8.195a1.065 1.065 0 1 0 0 2.13 1.065 1.065 0 0 0 0-2.13zM5.99 4.366l.17 3.148c.009.147.13.263.278.263h1.124c.148 0 .27-.116.277-.263l.172-3.148a.278.278 0 0 0-.277-.293H6.267a.278.278 0 0 0-.278.293z" />
    </svg>
  </Icon>
);
